module.exports = __webpack_public_path__ + "img/4.c5922cb7.jpeg";